// extracted by mini-css-extract-plugin
export default {"results":"search-result-list_results__kOAON","result":"search-result-list_result__lfc7C"};